export const TRAJECTORY_EVENTS = {
  TRAJECTORY_CLICKED: 'trajectory_clicked'
} as const

export type TrajectoryEvent = (typeof TRAJECTORY_EVENTS)[keyof typeof TRAJECTORY_EVENTS]
